import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ActionIconGrey } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';
import { getDestinationType, getObjectLink } from './util';

interface EPActionDueProps {
  showDate?: string;
  owner: string;
  action: {
    id: string;
    notes: string;
  };
  object: {
    id: string;
    name: string;
    type: string;
    assesmentId?: string;
  };
  truncate?: boolean;
}

export const EPActionDue: React.FC<EPActionDueProps> = ({ showDate, action, object, truncate }) => {
  return (
    <Base
      iconComponent={<ActionIconGrey />}
      constentComponent={
        <Text nowrap={truncate} $isPast>
          {showDate && <Text className="sdate sdate--past">{formatDate(showDate)}</Text>}
          Action{' '}
          <Link
            to={`${getObjectLink(object)}#actions`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: [getDestinationType(object.type)],
                  params: {
                    id: object.id,
                  },
                },
                tags: ['TIMELINE', 'ACTIONS'],
              })
            }
          >
            <TextLink>{action.notes}</TextLink>
          </Link>{' '}
          was due
        </Text>
      }
    />
  );
};
